import { ADDITIONAL_INFO_OPTIONS } from "../../../../common/utils/utils";

export const constructPathogenicityOptions = (variantClassesList) => {
  if (variantClassesList && Array.isArray(variantClassesList)) {
    return variantClassesList.map((c) => ({
      value: c.short_name,
      label: c.name,
    }));
  }
  return [];
};

export const getPathogenicityOptionFromShortName = (
  pathogenicity,
  variantClassesList
) => {
  const pathogenicityOptions =
    constructPathogenicityOptions(variantClassesList);
  for (let i = pathogenicityOptions.length - 1; i >= 0; i--) {
    if (pathogenicity === pathogenicityOptions[i].value)
      return pathogenicityOptions[i];
  }

  return "";
};

export const getAdditionalOptionsFromAdditionalInfo = (additional) => {
  if (!Array.isArray(additional)) return [];

  const res = [];
  for (const add of additional) {
    for (let i = ADDITIONAL_INFO_OPTIONS.length - 1; i >= 0; i--) {
      if (ADDITIONAL_INFO_OPTIONS[i].value === add) {
        res.push(ADDITIONAL_INFO_OPTIONS[i]);
        break;
      }
    }
  }

  return res;
};

export const noFlagSelectedOrLimitReached = (flag, total) => {
  if (!flag || total >= 100) {
    return true;
  }
  return false;
};
